import { GameState } from './GameState';
import { GameConfig } from '../core/GameConfig';

/**
 * 标签一次性效果注册表（特殊天赋的「一次性动作」挂载点）
 *
 * 挂载方式：增标签时若本表存在对应 tagId 的处理函数，则触发一次。
 * 适用场景：结识 NPC / 送剧本 / 赠与资源等语义不可逆的效果；
 *          移除标签（removeTag）不回滚。持续型修正（如事件概率）不要放这里，
 *          应在消费点实时 hasTag() 判断（自动失效）。
 *
 * 各效果与 docs/特性设计.md 的天赋池状态一一对应。
 */
export const TAG_EFFECTS: Record<string, (state: GameState) => void> = {
    /** 富家千金：开局自带 ¥50,000（首触即时拉满，此后金钱浮动不影响） */
    TAG_013: (state) => {
        state.setMoney(GameConfig.HEIRESS_START_MONEY);
        // 首触即达 20 万解锁线：带资进组同步解锁（setMoney 内部已自动触发 unlockBuyinIfEligible 并推送通知）
        console.log(`[TagEffects] 富家千金：金钱设为 ¥${GameConfig.HEIRESS_START_MONEY.toLocaleString()}，带资进组已解锁`);
    },
};

/**
 * 标签是否为富家千金（营销/叙事性判断，供外部使用）
 */
export function isHeiress(state: GameState): boolean {
    // 2026-10-19 身份拆分：富家千金改为 origin；兼容拆分前的老档标签
    return state.hasOrigin('TAG_013') || state.hasTag('TAG_013');
}